"use client";

export default function CTA() {
    return (
        <section className="relative overflow-hidden bg-[#173F3E] py-16 sm:py-20 lg:py-24">

            {/* Decorative Elements */}
            <div className="absolute -left-32 -top-32 h-80 w-80 rounded-full bg-[#B78932]/10 blur-3xl" />
            <div className="absolute -bottom-40 -right-32 h-96 w-96 rounded-full bg-[#D5A33C]/10 blur-3xl" />

            {/* Subtle Gold Lines */}
            <div className="absolute left-0 top-0 h-px w-full bg-gradient-to-r from-transparent via-[#B78932]/60 to-transparent" />
            <div className="absolute bottom-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-[#B78932]/40 to-transparent" />

            <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                <div className="mx-auto max-w-4xl text-center">

                    {/* Eyebrow */}
                    <div className="mb-5 flex items-center justify-center gap-3">
                        <span className="h-px w-10 bg-[#B78932]" />

                        <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#D5A33C]">
                            Your Dubai Stay Awaits
                        </span>

                        <span className="h-px w-10 bg-[#B78932]" />
                    </div>


                    {/* Heading */}
                    <h2 className="font-serif text-4xl font-medium leading-tight !text-[#FBFAF6] sm:text-5xl lg:text-6xl">
                        Find a Stay Worth
                        <span className="block text-[#D5A33C]">
                            Remembering
                        </span>
                    </h2>


                    {/* Description */}
                    <p className="mx-auto mt-6 max-w-2xl text-sm leading-7 text-[#D9DEDA] sm:text-base">
                        From iconic beachfront resorts to elegant city hotels,
                        discover the right Dubai stay at the right rate.
                        Compare your options and book with confidence.
                    </p>


                    {/* CTA BUTTONS */}
                    <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">

                        {/* Primary Button */}
                        <button
                            type="button"
                            className="group inline-flex min-w-[190px] items-center justify-center gap-3 border border-[#D5A33C] bg-[#D5A33C] px-7 py-3.5 text-sm font-semibold text-[#173F3E] transition-all duration-300 hover:bg-[#B78932] hover:text-white"
                        >
                            Explore Dubai Hotels

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.7}
                                stroke="currentColor"
                                className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                                />
                            </svg>
                        </button>


                        {/* Secondary Button */}
                        <button
                            type="button"
                            className="inline-flex min-w-[190px] items-center justify-center border border-[#E7DED0]/40 bg-transparent px-7 py-3.5 text-sm font-semibold text-[#FBFAF6] transition-all duration-300 hover:border-[#D5A33C] hover:bg-[#FBFAF6] hover:text-[#173F3E]"
                        >
                            Compare Hotel Rates
                        </button>

                    </div>


                    {/* Trust Points */}
                    <div className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-xs text-[#C7D0CC]">

                        <div className="flex items-center gap-2">
                            <span className="flex h-5 w-5 items-center justify-center rounded-full border border-[#B78932] text-[#D5A33C]">
                                ✓
                            </span>
                            Best available rates
                        </div>

                        <div className="hidden h-4 w-px bg-[#E7DED0]/20 sm:block" />

                        <div className="flex items-center gap-2">
                            <span className="flex h-5 w-5 items-center justify-center rounded-full border border-[#B78932] text-[#D5A33C]">
                                ✓
                            </span>
                            Trusted hotel choices
                        </div>

                        <div className="hidden h-4 w-px bg-[#E7DED0]/20 sm:block" />

                        <div className="flex items-center gap-2">
                            <span className="flex h-5 w-5 items-center justify-center rounded-full border border-[#B78932] text-[#D5A33C]">
                                ✓
                            </span>
                            Secure booking
                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
}
